import { style } from '@vanilla-extract/css';

// The blur leaves nothing of the terminal readable behind a modal the tour
// opened, and the tour is explaining what sits behind it.
export const tourOverlay = style({
  backdropFilter: 'none',
});
